export default import.meta.ROLLDOWN_FILE_URL_YR4mm221GKPbwdJSn5Ca3g